module.exports =
/******/
function (modules) {
  // webpackBootstrap

  /******/
  // The module cache

  /******/
  var installedModules = {};
  /******/

  /******/
  // The require function

  /******/

  function __webpack_require__(moduleId) {
    /******/

    /******/
    // Check if module is in cache

    /******/
    if (installedModules[moduleId]) {
      /******/
      return installedModules[moduleId].exports;
      /******/
    }
    /******/
    // Create a new module (and put it into the cache)

    /******/


    var module = installedModules[moduleId] = {
      /******/
      i: moduleId,

      /******/
      l: false,

      /******/
      exports: {}
      /******/

    };
    /******/

    /******/
    // Execute the module function

    /******/

    modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
    /******/

    /******/
    // Flag the module as loaded

    /******/

    module.l = true;
    /******/

    /******/
    // Return the exports of the module

    /******/

    return module.exports;
    /******/
  }
  /******/

  /******/

  /******/
  // expose the modules object (__webpack_modules__)

  /******/


  __webpack_require__.m = modules;
  /******/

  /******/
  // expose the module cache

  /******/

  __webpack_require__.c = installedModules;
  /******/

  /******/
  // define getter function for harmony exports

  /******/

  __webpack_require__.d = function (exports, name, getter) {
    /******/
    if (!__webpack_require__.o(exports, name)) {
      /******/
      Object.defineProperty(exports, name, {
        /******/
        configurable: false,

        /******/
        enumerable: true,

        /******/
        get: getter
        /******/

      });
      /******/
    }
    /******/

  };
  /******/

  /******/
  // getDefaultExport function for compatibility with non-harmony modules

  /******/


  __webpack_require__.n = function (module) {
    /******/
    var getter = module && module.__esModule ?
    /******/
    function getDefault() {
      return module['default'];
    } :
    /******/
    function getModuleExports() {
      return module;
    };
    /******/

    __webpack_require__.d(getter, 'a', getter);
    /******/


    return getter;
    /******/
  };
  /******/

  /******/
  // Object.prototype.hasOwnProperty.call

  /******/


  __webpack_require__.o = function (object, property) {
    return Object.prototype.hasOwnProperty.call(object, property);
  };
  /******/

  /******/
  // __webpack_public_path__

  /******/


  __webpack_require__.p = "";
  /******/

  /******/
  // Load entry module and return exports

  /******/

  return __webpack_require__(__webpack_require__.s = 199);
  /******/
}(
/************************************************************************/

/******/
{
  /***/
  0:
  /***/
  function _(module, exports) {
    module.exports = require("react");
    /***/
  },

  /***/
  1:
  /***/
  function _(module, exports) {
    module.exports = require("prop-types");
    /***/
  },

  /***/
  199:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _reducer = __webpack_require__(200);

    Object.defineProperty(exports, 'modalReducer', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_reducer).default;
      }
    });

    var _ModalHostContainer = __webpack_require__(201);

    Object.defineProperty(exports, 'ModalHost', {
      enumerable: true,
      get: function get() {
        return _interopRequireDefault(_ModalHostContainer).default;
      }
    });

    var _actionCreators = __webpack_require__(68);

    Object.defineProperty(exports, 'pushModal', {
      enumerable: true,
      get: function get() {
        return _actionCreators.pushModal;
      }
    });
    Object.defineProperty(exports, 'popModal', {
      enumerable: true,
      get: function get() {
        return _actionCreators.popModal;
      }
    });
    Object.defineProperty(exports, 'closeModal', {
      enumerable: true,
      get: function get() {
        return _actionCreators.closeModal;
      }
    });

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }
    /***/

  },

  /***/
  2:
  /***/
  function _(module, exports) {
    module.exports = require("classnames");
    /***/
  },

  /***/
  200:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.default = modal;

    var _actionTypes = __webpack_require__(67);

    var actionTypes = _interopRequireWildcard(_actionTypes);

    function _interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      } else {
        var newObj = {};

        if (obj != null) {
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
          }
        }

        newObj.default = obj;
        return newObj;
      }
    }

    function _toConsumableArray(arr) {
      if (Array.isArray(arr)) {
        for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
          arr2[i] = arr[i];
        }

        return arr2;
      } else {
        return Array.from(arr);
      }
    }

    var initialState = [];

    function modal() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
      var action = arguments[1];

      switch (action.type) {
        case actionTypes.PUSH_MODAL:
          return [].concat(_toConsumableArray(state), [{
            modalType: action.modalType,
            modalProps: action.modalProps
          }]);

        case actionTypes.POP_MODAL:
          return state.slice(0, -1);

        case actionTypes.CLOSE_MODAL:
          return initialState;

        default:
          return state;
      }
    }
    /***/

  },

  /***/
  201:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _reactRedux = __webpack_require__(202);

    var _redux = __webpack_require__(203);

    var _ModalHost = __webpack_require__(204);

    var _ModalHost2 = _interopRequireDefault(_ModalHost);

    var _actionCreators = __webpack_require__(68);

    var actionCreators = _interopRequireWildcard(_actionCreators);

    function _interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      } else {
        var newObj = {};

        if (obj != null) {
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
          }
        }

        newObj.default = obj;
        return newObj;
      }
    }

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function mapStateToProps(state) {
      return {
        modals: state.modals
      };
    }

    function mapDispatchToProps(dispatch) {
      return (0, _redux.bindActionCreators)(actionCreators, dispatch);
    }

    exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_ModalHost2.default);
    /***/
  },

  /***/
  202:
  /***/
  function _(module, exports) {
    module.exports = require("react-redux");
    /***/
  },

  /***/
  203:
  /***/
  function _(module, exports) {
    module.exports = require("redux");
    /***/
  },

  /***/
  204:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });

    var _slicedToArray = function () {
      function sliceIterator(arr, i) {
        var _arr = [];
        var _n = true;
        var _d = false;
        var _e = undefined;

        try {
          for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
            _arr.push(_s.value);

            if (i && _arr.length === i) break;
          }
        } catch (err) {
          _d = true;
          _e = err;
        } finally {
          try {
            if (!_n && _i["return"]) _i["return"]();
          } finally {
            if (_d) throw _e;
          }
        }

        return _arr;
      }

      return function (arr, i) {
        if (Array.isArray(arr)) {
          return arr;
        } else if (Symbol.iterator in Object(arr)) {
          return sliceIterator(arr, i);
        } else {
          throw new TypeError("Invalid attempt to destructure non-iterable instance");
        }
      };
    }();

    var _extends = Object.assign || function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };

    var _createClass = function () {
      function defineProperties(target, props) {
        for (var i = 0; i < props.length; i++) {
          var descriptor = props[i];
          descriptor.enumerable = descriptor.enumerable || false;
          descriptor.configurable = true;
          if ("value" in descriptor) descriptor.writable = true;
          Object.defineProperty(target, descriptor.key, descriptor);
        }
      }

      return function (Constructor, protoProps, staticProps) {
        if (protoProps) defineProperties(Constructor.prototype, protoProps);
        if (staticProps) defineProperties(Constructor, staticProps);
        return Constructor;
      };
    }();

    var _propTypes = __webpack_require__(1);

    var _propTypes2 = _interopRequireDefault(_propTypes);

    var _react = __webpack_require__(0);

    var _react2 = _interopRequireDefault(_react);

    var _reactTransitionGroup = __webpack_require__(205);

    var _classnames = __webpack_require__(2);

    var _classnames2 = _interopRequireDefault(_classnames);

    var _forEach = __webpack_require__(206);

    var _forEach2 = _interopRequireDefault(_forEach);

    var _get = __webpack_require__(207);

    var _get2 = _interopRequireDefault(_get);

    function _interopRequireDefault(obj) {
      return obj && obj.__esModule ? obj : {
        default: obj
      };
    }

    function _classCallCheck(instance, Constructor) {
      if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
      }
    }

    function _possibleConstructorReturn(self, call) {
      if (!self) {
        throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
      }

      return call && (typeof call === "object" || typeof call === "function") ? call : self;
    }

    function _inherits(subClass, superClass) {
      if (typeof superClass !== "function" && superClass !== null) {
        throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
      }

      subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
          value: subClass,
          enumerable: false,
          writable: true,
          configurable: true
        }
      });
      if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
    }

    var ModalHost = function (_Component) {
      _inherits(ModalHost, _Component);

      function ModalHost() {
        var _ref;

        var _temp, _this, _ret;

        _classCallCheck(this, ModalHost);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ModalHost.__proto__ || Object.getPrototypeOf(ModalHost)).call.apply(_ref, [this].concat(args))), _this), _this.closeModal = function () {
          var closeModal = _this.props.closeModal;

          var _this$getActiveModalP = _this.getActiveModalProps(),
              onCloseModal = _this$getActiveModalP.onCloseModal;

          closeModal();

          if (onCloseModal) {
            onCloseModal();
          }
        }, _this.handleKeyDown = function (_ref2) {
          var keyCode = _ref2.keyCode;

          var _this$getActiveModalP2 = _this.getActiveModalProps(),
              disableEscape = _this$getActiveModalP2.disableEscape,
              isCloseable = _this$getActiveModalP2.isCloseable;

          if (!disableEscape && isCloseable && keyCode === 27) {
            _this.closeModal();
          }
        }, _this.renderModal = function (_ref3) {
          var modalType = _ref3.modalType,
              modalProps = _ref3.modalProps;
          var _this$props = _this.props,
              modals = _this$props.modals,
              popModal = _this$props.popModal,
              modalMap = _this$props.modalMap;
          var Modal = modalMap[modalType];
          var isVisible = modalType === modals[modals.length - 1].modalType;

          var props = _extends({}, modalProps, {
            popModal: popModal,
            closeModal: _this.closeModal
          });

          return _react2.default.createElement('div', {
            className: 'modal-container concealed',
            key: modalType,
            ref: function ref(node) {
              return _this.modals.push([node, isVisible]);
            }
          }, Modal && _react2.default.createElement(Modal, props));
        }, _temp), _possibleConstructorReturn(_this, _ret);
      }

      _createClass(ModalHost, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          window.addEventListener('keydown', this.handleKeyDown);
          this.animate();
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
          this.animate();
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          window.removeEventListener('keydown', this.handleKeyDown);
          this.modals = [];
        }
      }, {
        key: 'animate',
        value: function animate() {
          var _this2 = this;

          (0, _forEach2.default)(this.modals, function (_ref4) {
            var _ref5 = _slicedToArray(_ref4, 2),
                modal = _ref5[0],
                isVisible = _ref5[1];

            if (modal) {
              var containerClasses = (0, _classnames2.default)('modal-container', isVisible ? 'disclosed' : 'concealed pointerEvents-none');
              setTimeout(function () {
                /* eslint-disable no-param-reassign */
                modal.className = containerClasses;
                modal.style.position = isVisible ? null : 'fixed';
              }, 0);
            }
          });

          if (this.node) {
            var modals = this.props.modals;

            if (modals.length) {
              setTimeout(function () {
                _this2.node.className = (0, _classnames2.default)('modal-overlay', 'modal-overlay--fade', 'is-active');
              }, 0);
            } else {
              this.node.className = (0, _classnames2.default)('modal-overlay', 'modal-overlay--fade');
            }
          }
        }
      }, {
        key: 'getActiveModalProps',
        value: function getActiveModalProps() {
          var modals = this.props.modals;
          return (0, _get2.default)(modals, '[' + (modals.length - 1) + '].modalProps', {});
        }
      }, {
        key: 'render',
        value: function render() {
          var _this3 = this;
          /* eslint-disable jsx-a11y/no-static-element-interactions */


          var _props = this.props,
              modals = _props.modals,
              popModal = _props.popModal;
          var overlayClasses = (0, _classnames2.default)('modal-overlay', 'modal-overlay--fade');

          var _getActiveModalProps = this.getActiveModalProps(),
              backButton = _getActiveModalProps.backButton,
              _getActiveModalProps$ = _getActiveModalProps.isCloseable,
              isCloseable = _getActiveModalProps$ === undefined ? true : _getActiveModalProps$;

          var renderBackButton = modals.length > 1 && backButton !== false;
          this.modals = [];
          return _react2.default.createElement('div', {
            className: overlayClasses,
            ref: function ref(node) {
              _this3.node = node;
            }
          }, _react2.default.createElement(_reactTransitionGroup.CSSTransitionGroup, {
            transitionName: {
              leave: 'concealed'
            },
            transitionEnter: false,
            transitionLeaveTimeout: 300
          }, modals.map(this.renderModal)), _react2.default.createElement('div', {
            className: 'modal-icon-wrapper'
          }, renderBackButton && _react2.default.createElement('div', {
            className: 'modal-icon modal-icon--light modal-iconBack',
            onClick: popModal
          }), isCloseable && _react2.default.createElement('div', {
            className: 'modal-icon modal-icon--light modal-iconClose',
            onClick: this.closeModal
          })));
        }
      }]);

      return ModalHost;
    }(_react.Component);

    ModalHost.propTypes = {
      modalMap: _propTypes2.default.object.isRequired,
      modals: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        modalType: _propTypes2.default.string.isRequired,
        modalProps: _propTypes2.default.object.isRequired
      })).isRequired,
      closeModal: _propTypes2.default.func.isRequired,
      popModal: _propTypes2.default.func.isRequired
    };
    exports.default = ModalHost;
    /***/
  },

  /***/
  205:
  /***/
  function _(module, exports) {
    module.exports = require("react-transition-group");
    /***/
  },

  /***/
  206:
  /***/
  function _(module, exports) {
    module.exports = require("lodash/forEach");
    /***/
  },

  /***/
  207:
  /***/
  function _(module, exports) {
    module.exports = require("lodash/get");
    /***/
  },

  /***/
  67:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    var PUSH_MODAL = exports.PUSH_MODAL = '@@marvel-ui-modal-redux/PUSH_MODAL';
    var POP_MODAL = exports.POP_MODAL = '@@marvel-ui-modal-redux/POP_MODAL';
    var CLOSE_MODAL = exports.CLOSE_MODAL = '@@marvel-ui-modal-redux/CLOSE_MODAL';
    /***/
  },

  /***/
  68:
  /***/
  function _(module, exports, __webpack_require__) {
    "use strict";

    Object.defineProperty(exports, "__esModule", {
      value: true
    });
    exports.pushModal = pushModal;
    exports.popModal = popModal;
    exports.closeModal = closeModal;

    var _actionTypes = __webpack_require__(67);

    var actionTypes = _interopRequireWildcard(_actionTypes);

    function _interopRequireWildcard(obj) {
      if (obj && obj.__esModule) {
        return obj;
      } else {
        var newObj = {};

        if (obj != null) {
          for (var key in obj) {
            if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key];
          }
        }

        newObj.default = obj;
        return newObj;
      }
    }

    function pushModal(modalType) {
      var modalProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      return {
        type: actionTypes.PUSH_MODAL,
        modalType: modalType,
        modalProps: modalProps
      };
    }

    function popModal() {
      return {
        type: actionTypes.POP_MODAL
      };
    }

    function closeModal() {
      return {
        type: actionTypes.CLOSE_MODAL
      };
    }
    /***/

  }
  /******/

});